export default __webpack_public_path__ + "static/media/neuron.583417f3.svg";